import { Component, Input } from '@angular/core';
import { EditableAccount } from '../../model/account.model';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'jhi-identite-organisme',
    templateUrl: './identite-organisme.component.html',
    styleUrls: ['./identite-organisme.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class IdentiteOrganismeComponent {
    @Input()
    identite: EditableAccount;

    @Input()
    isCreateAccountBtnClicked: boolean;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/identite-organisme/identite-organisme.component.ts